export default __webpack_public_path__ + "static/media/6-1.8e5d69b1.mp3";